export * from './layer';
export * from './popup';
export * from './drawMode';
/**
 * update map properties action creator
 *
 * @param {object} properties - {zoom, center}
 * @returns {{payload: *, type: string}}
 */
export const updateMapProperties = properties => {
    return {
        type   : 'UPDATE_MAP_PROPERTIES',
        payload: properties
    };
};

/**
 * update map to zoom to an extent action creator
 *
 * @param {array} extent - array of coordinates [ xMin, yMin, xMax, yMax, ]
 * @returns {{payload: *, type: string}}
 */
export const zoomMapToExtent = extent => {
    return {
        type   : 'ZOOM_MAP_TO_EXTENT',
        payload: extent
    };
};

/**
 * update base layer / basemap
 *
 * @param {string} baseLayers - name of the base layer
 * @returns {{payload: *, type: string}}
 */
export const updateBaseLayer = baseLayer => {
    return {
        type   : 'UPDATE_BASE_LAYER',
        payload: baseLayer
    };
};

/**
 * minify status for legends
 *
 * @param {boolean} status
 * @returns {{payload: *, type: string}}
 */
export const minifyLegends = status => {
    return {
        type   : 'MINIFY_LEGENDS',
        payload: status
    };
};

/**
 * display/hide detail panel
 *
 * @param {boolean} status
 * @returns {{payload: *, type: string}}
 */
export const displayDetailPanel = data => {
    return {
        type   : 'DISPLAY_DETAIL_PANEL',
        payload: data
    };
};

/**
 * display/hide tooltip
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const displayMapTooltip = data => {
    return {
        type:  'DISPLAY_MAP_TOOLTIP',
        payload: data,
    };
};

/**
 * display hide opacity slider
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const displayOpacitySlider = data => {
    return {
        type   : 'DISPLAY_OPACITY_SLIDER',
        payload: data
    };
};

/**
 * change layer opacity action creator
 *
 * @param layer
 * @returns {{payload: *, type: string}}
 */
export const changeLayerOpacity = layer => {
    return {
        type   : 'LAYER_OPACITY_CHANGED',
        payload: layer
    };
};

/**
 * update sipalaga chart data
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const sipalagaDetailPanelUpdateChart = data => {
    return {
        type   : 'UPDATE_SIPALAGA_DETAIL_PANEL_CHART',
        payload: data
    }
}

/**
 * update mitra restorasi filter data
 *
 * @param data
 * @returns {{payload: *, type: string}}
 * @constructor
 */
export const loadMitraRestorasiFilterData = data => {
    return {
        type   : 'UPDATE_MITRA_RESTORASI_FILTER_DATA',
        payload: data
    }
}
/**
 * display multistack action
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const displayMultistack = data => {
    return {
        type   : 'DISPLAY_MULTISTACK',
        payload: data,
    }
}

/**
 * toggle mobile menu status
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const toggleMobileMenu = data => {
    return {
        type   : 'TOGGLE_MOBILE_MENU',
        payload: data,
    }
}

/**
 * toggle adhoc layer panel
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const toggleAdhocLayerPanel = data => {
    return {
        type   : 'TOGGLE_ADHOC_LAYER_PANEL',
        payload: data,
    }
}

/**
 * add adhoc layer data
 *
 * @param data
 */
export const addAdhocLayer = data => {
    return {
        type   : 'ADD_ADHOC_LAYER',
        payload: data,
    }
}

/**
 * set hotspot mode
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const setHotspotMode = data => {
    return {
        type   : 'SET_HOTSPOT_MODE',
        payload: data,
    }
}

/**
 * display maps overlay
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const displayMapsOverlay = data => {
    return {
        type   : 'DISPLAY_MAPS_OVERLAY',
        payload: data,
    }
}

/**
 * set user data
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const setUserData = data => {
    return {
        type   : 'SET_USER_DATA',
        payload: data,
    }
}

export const addCoordinateSearchLayer = coordinates => {
    return {
        type   : 'ADD_COORDINATE_SEARCH_LAYER',
        payload: coordinates,
    }
}

export const removeCoordinateSearchLayer = coordinates => {
    return {
        type   : 'REMOVE_COORDINATE_SEARCH_LAYER',
        payload: coordinates,
    }
}